const LoadingStates = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
  AUTHENTICATING: 'AUTHENTICATING',
};

export { LoadingStates };
